/**
 * 数値を3桁ごとにカンマ区切りした文字列を返す
 * @param value フォーマットする数値（nullやundefinedも許容）
 * @returns カンマ区切りされた文字列
 */
export function formatNumberWithCommas (value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) {
    return ''
  }
  return value.toLocaleString('ja-JP')
}
